import { render, staticRenderFns } from "./editIndexPopAd.vue?vue&type=template&id=64520398&scoped=true&"
import script from "./editIndexPopAd.vue?vue&type=script&lang=js&"
export * from "./editIndexPopAd.vue?vue&type=script&lang=js&"
import style0 from "./editIndexPopAd.vue?vue&type=style&index=0&id=64520398&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64520398",
  null
  
)

export default component.exports